export enum BulkActionField {
  Category = "Category",
  Party = "Party",
  ReconciliationStatus = "ReconciliationStatus",
  TaxStatus = "TaxStatus",
  SplitCategory = "SplitCategory",
}

export const BULK_FIELD_WIDTH = 185
export const BULK_STATUS_UPDATE_LIMIT = 200
export const BULK_HEADER_HEIGHT = 81
